import { useTranslation } from 'react-i18next';

import styles from './FollowingSearchEmptyState.module.scss';

/**
 * @deprecated
 */
export const FollowingSearchEmptyState = () => {
  const { t } = useTranslation('onboarding');

  return (
    <div className={styles.root} data-testid="following-search-empty-state">
      <img
        className={styles.image}
        src="/app/static/images/empty-state/no-search-result.svg"
        alt=""
      />
      <span className={styles.description}>
        {t('onboarding:following.searchNoResults')}
      </span>
    </div>
  );
};
